
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { closeAllModal, setResultModalData, showModal } from "../modal/modalSlice";
import { toast } from "react-toastify";

const initialState = {

  isLoadingGetYukbulBlockingMessages: false,
  yukbulBlockingMessagesList: [],

  isLoadingAddYukbulBlockingMessage: false,

  blockingMessageFilterItem: null,

  isLoadingDeleteYukbulBlockingMessage: false,

  isLoadingGetYukbulMessages: false,
  allYukbulMessages: [],
  allYukbulMessagesMobile: [],
  allYukbulMessagesMobileCount: null,


  isLoadingGetYukbulMessagesCount: false,
  allYukbulMessagesCount: null,

  lookingLoadList: [],
  lookingLoadListCount: null,
  lookinLoadInfo: null,

  feedBackList: [],
  feedBackListCount: null,

  appRoleList: [],

  adminRoleList: [],
  allClaimsByRole: [],
  selectedRole: null,

  //! sayfa oluşturma için
  selectedMenu: null,
  selectedPage: null,

  isLoadingGet: false,
  isLoadingAdd: false,

  smsReportList: [],

  yukBulSelectedMessages: [],

  isLoadingDeleteYukBulItems: false,

  isLoadingShareYukBulItems: false,



  //! ***********************************************************

  isLoadingGetDeleteUserRequestsForPortal: false,

  deleteUserRequestsForPortalList: [],

  deleteUserRequestsForPortalCount: 0,

  deleteUserRequestsForPortalSize: 0

  

};
    
  export const getYukbulBlockingMessages = createAsyncThunk("admin5/getYukbulBlockingMessages",async ({blockingMessageFilterText, blockingMessageFilterType}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/WhatsAppSelenium/GetWhatsAppLoadOfferFilters`);

      const list = data.$values.reverse()

      if(blockingMessageFilterType.value === 0){

        if(blockingMessageFilterText === ""){
          return list
        }
        else{
          return list.filter(item => {
            return item.filterValue.toLocaleLowerCase("tr").includes(blockingMessageFilterText.toLocaleLowerCase("tr"))
          })
        }
      }
      else if(blockingMessageFilterType.value === 1){
        if(blockingMessageFilterText === ""){
          return list.filter(item => {
            return item.filterType === 1
          })
        }
        else{
          return list.filter(item => {
            return item.filterType === 1 && item.filterValue.toLocaleLowerCase("tr").includes(blockingMessageFilterText.toLocaleLowerCase("tr"))
          })
        }
      }
      else{
        if(blockingMessageFilterText === ""){
          return list.filter(item => {
            return item.filterType === 2
          })
        }
        else{
          return list.filter(item => {
            return item.filterType === 2 && item.filterValue.toLocaleLowerCase("tr").includes(blockingMessageFilterText.toLocaleLowerCase("tr"))
          })
        }
      }
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const addYukbulBlockingMessage = createAsyncThunk("admin5/addYukbulBlockingMessage",async (blockingItem, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/WhatsAppSelenium/AddWhatsAppLoadOfferFilter`, blockingItem);
        if(data.id){
          // thunkApi.dispatch(closeAllModal())
          //  toast.success('Mesaj engelleme işlemi başarı ile gerçekleştiridi.', {
          //             position: "bottom-right",
          //             autoClose: 2000,
          //             hideProgressBar: false,
          //             closeOnClick: true,
          //             pauseOnHover: true,
          //             draggable: true,
          //             progress: undefined,
          //             theme: "light",
          //         });
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Mesaj engelleme işlemi başarı ile gerçekleştiridi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
          return data
      }
      else{
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
      }
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const deleteYukbulBlockingMessage = createAsyncThunk("admin5/deleteYukbulBlockingMessage",async (deletedItemId, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.delete(`/WhatsAppSelenium/DeleteWhatsAppLoadOfferFilter?id=${deletedItemId}`);
        if(data.id){
          // thunkApi.dispatch(closeAllModal())
          //  toast.success('Mesaj engeli kaldırma işlemi başarı ile gerçekleştiridi.', {
          //             position: "bottom-right",
          //             autoClose: 2000,
          //             hideProgressBar: false,
          //             closeOnClick: true,
          //             pauseOnHover: true,
          //             draggable: true,
          //             progress: undefined,
          //             theme: "light",
          //         });
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Mesaj engeli kaldırma işlemi başarı ile gerçekleştiridi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
          return data
        }
        else{
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", btnText1: "Listeyi Görüntüle"}))
      }
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const getYukbulMessages = createAsyncThunk("admin5/getYukbulMessages",async ({filterText, filterCity, phoneNumber, size, from}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/WhatsAppSelenium/GetWhatsAppLoadOffers?size=${from === "block" ? 10000 : size}${phoneNumber ? `&&phoneNumber=${phoneNumber}`: "" }${filterText ? `&&filterText=${filterText.toLocaleLowerCase("tr")}`: "" }${filterCity ? `&&filterTextCity=${filterCity}`: "" }`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const getYukbulMessagesCount = createAsyncThunk("admin5/getYukbulMessagesCount",async ({filterText, filterCity, phoneNumber}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/WhatsAppSelenium/GetTotalWhatsAppLoadOfferCount?${phoneNumber ? `phoneNumber=${phoneNumber}`: "" }${filterText ? `&&filterText=${filterText.toLocaleLowerCase("tr")}`: "" }${filterCity ? `&&filterTextCity=${filterCity}`: "" }`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! yük bul mobil
  export const getYukbulMessagesMobile = createAsyncThunk("admin5/getYukbulMessagesMobile",async ({filterText, filterCity, phoneNumber, page}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/WhatsAppSelenium/GetMobileWhatsAppLoadOffersForAdmin?page=${page}&&${phoneNumber ? `&&phoneNumber=${phoneNumber}`: "" }${filterText ? `&&filterText=${filterText.toLocaleLowerCase("tr")}`: "" }${filterCity ? `&&filterTextCity=${filterCity}`: "" }`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! yük arıyorum
  export const getLookingLoadAdmin = createAsyncThunk("admin5/getLookingLoadAdmin",async ({page, name = "", startPoint = "", endPoint = ""}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/YukArayan/GetAdminYukAriyorumInfos?page=${page}&&name=${name}&&startPoint=${startPoint}&&endPoint=${endPoint}`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! yük arıyorum detay
  export const getLookingLoadInfoAdmin = createAsyncThunk("admin5/getLookingLoadInfoAdmin",async (id, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/YukArayan/GetAdminYukAriyorumNotifications?userId=${id}`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const deleteYukBulItems = createAsyncThunk("admin5/deleteYukBulItems",async (list, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`WhatsAppSelenium/DeleteWhatsAppLoadOffer`, list);
        if(data.statusCode === 200){
          thunkApi.dispatch(getYukbulMessages({
            size:200
          }))
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Mesaj silme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      else{
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }
    
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  export const shareYukBulItems = createAsyncThunk("admin5/shareYukBulItems",async (body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`WhatsAppSelenium/SendWhatsAppLoadOfferNotification`, body);

        if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bildirim gönderme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      else{
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }

    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  //! net gsm sms bildirimleri
  export const getFailedNetgsmSmsReport = createAsyncThunk("admin5/getFailedNetgsmSmsReport",async ( {number}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/user/GetFailedNetgsmSmsReport?number=${number}`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! sayfa veya menü oluşturma
  export const addNewPageOrMenu = createAsyncThunk("admin5/addNewPageOrMenu",async ( body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Identities/AddAspNetClaim`, body);
        if(data){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Sayfa başarılı bir şekilde eklendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });

  //! sayfa veya menü güncelleme
  
  export const updatePageOrMenu = createAsyncThunk("admin5/updatePageOrMenu",async ( body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Identities/UpdateAspNetClaim`, body);
      if(data){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Sayfa başarılı bir şekilde güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });

  //! sayfa veya menü silme
  export const deletePageOrMenu = createAsyncThunk("admin5/deletePageOrMenu",async ( body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Identities/DeleteAspNetClaim`, body);
      if(data){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Sayfa başarılı bir şekilde silindi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });

  //! mobil feedback
  export const getCallFeedback = createAsyncThunk("admin5/getCallFeedback",async ( {page = 1, phoneNumber = "", feedbackType = ""}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/WhatsAppSelenium/CallFeedback?PhoneNumber=${phoneNumber}&FeedbackType=${feedbackType}&page=${page}`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  //! portal tüm roller
  export const getAllAppRole = createAsyncThunk("admin5/getAllAppRole",async ( _, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/Identities/GetAllAppRole`);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! portal rol ismi güncelle
  export const updateAppRole = createAsyncThunk("admin5/updateAppRole",async ( _, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Identities/UpdateAppRole`);
      if(data){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Rol adı başarılı bir şekilde güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });

  //! admine göre rol getirme
  export const getRoleClaim = createAsyncThunk("admin5/getRoleClaim",async ( {role}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/Identities/GetRoleClaim?name=${role}`);
      
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! adminlerin alabileceği rollerin listesi
  export const getAllClaimsByRole = createAsyncThunk("admin5/getAllClaimsByRole",async ( _, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/Identities/GetAllClaimsByRole`);
      
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! rol tanımlama
  export const addRoleClaim = createAsyncThunk("admin5/addRoleClaim",async ( body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Identities/AddRoleClaim`, body);
      if(data){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Yetkiler başarılı bir şekilde güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
      }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });


export const getDeleteUserRequestsForPortal = createAsyncThunk(
  "admin5/getDeleteUserRequestsForPortal",
  async (queryParams = {}, thunkApi) => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(queryParams).filter(
          ([, value]) => value !== "" && value !== null && value !== undefined
        )
      );

      const { data } = await axiosInstance.get(
        `/User/GetDeleteUserRequestsForPortal`,
        {
          params: cleanedParams,
        }
      );

      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Bir hata meydana geldi.",
          resultType: "error",
          btnText1: "Kapat",
        })
      );

      return thunkApi.rejectWithValue(error);
    }
  }
);
  

const admin5Slice = createSlice({
  name: "admin5",
  initialState,
  reducers: {

    setBlockingMessageFilterItem: (state,action) => {
      state.blockingMessageFilterItem = action.payload
    },

    setYukbulMessages: (state, action) => {
      state.allYukbulMessages = action.payload
      state.allYukbulMessagesCount = null
    },

    setYukBulSelectedMessages: (state,action)=> {

      const {id} = action.payload

      if(state.yukBulSelectedMessages.find(item => item.id === id)){
        state.yukBulSelectedMessages = state.yukBulSelectedMessages.filter(item => {
          return item.id !== id
        })
      }
      else{
        state.yukBulSelectedMessages = [...state.yukBulSelectedMessages, action.payload]
      }
    },

    setSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload 
    },

    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload 
    },

    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload 
    }

  },
  extraReducers: (builder) => {
    builder

        //! getYukbulBlockingMessages
        .addCase(getYukbulBlockingMessages.pending, (state)=> {
          state.isLoadingGetYukbulBlockingMessages = true
        })
        .addCase(getYukbulBlockingMessages.fulfilled, (state, action)=> {
            state.isLoadingGetYukbulBlockingMessages = false
            state.yukbulBlockingMessagesList = action.payload
        })
        .addCase(getYukbulBlockingMessages.rejected, (state, action)=> {
            state.isLoadingGetYukbulBlockingMessages = false
        })


        //! addYukbulBlockingMessage
        .addCase(addYukbulBlockingMessage.pending, (state)=> {
          state.isLoadingAddYukbulBlockingMessage = true
        })
        .addCase(addYukbulBlockingMessage.fulfilled, (state, action)=> {
            state.isLoadingAddYukbulBlockingMessage = false
            state.yukbulBlockingMessagesList = [action.payload, ...state.yukbulBlockingMessagesList]
        })
        .addCase(addYukbulBlockingMessage.rejected, (state, action)=> {
            state.isLoadingAddYukbulBlockingMessage = false
        })

        //! deleteYukbulBlockingMessage
        .addCase(deleteYukbulBlockingMessage.pending, (state)=> {
          state.isLoadingDeleteYukbulBlockingMessage = true
        })
        .addCase(deleteYukbulBlockingMessage.fulfilled, (state, action)=> {
            state.isLoadingDeleteYukbulBlockingMessage = false
            state.yukbulBlockingMessagesList = state.yukbulBlockingMessagesList.filter(item => {
              return item?.id !== action?.payload?.id
            })
        })
        .addCase(deleteYukbulBlockingMessage.rejected, (state, action)=> {
            state.isLoadingDeleteYukbulBlockingMessage = false
        })


        //! getYukbulMessages
        .addCase(getYukbulMessages.pending, (state)=> {
          state.isLoadingGetYukbulMessages = true
        })
        .addCase(getYukbulMessages.fulfilled, (state, action)=> {
            state.isLoadingGetYukbulMessages = false
            state.allYukbulMessages = Array.from(new Map(action.payload.$values.map(item => [item.id, item])).values());
        })
        .addCase(getYukbulMessages.rejected, (state, action)=> {
            state.isLoadingGetYukbulMessages = false
        })

        //! getYukbulMessagesCount
        .addCase(getYukbulMessagesCount.pending, (state)=> {
          state.isLoadingGetYukbulMessagesCount = true
        })
        .addCase(getYukbulMessagesCount.fulfilled, (state, action)=> {
            state.isLoadingGetYukbulMessagesCount = false
            state.allYukbulMessagesCount = action.payload.data
        })
        .addCase(getYukbulMessagesCount.rejected, (state, action)=> {
            state.isLoadingGetYukbulMessagesCount = false
        })

        //! getYukbulMessagesMobile
        .addCase(getYukbulMessagesMobile.pending, (state)=> {
          state.isLoadingGetYukbulMessages = true
        })
        .addCase(getYukbulMessagesMobile.fulfilled, (state, action)=> {
            state.isLoadingGetYukbulMessages = false
            state.allYukbulMessagesMobile = action.payload.data.items.$values
            state.allYukbulMessagesMobileCount = action.payload.data.count
        })
        .addCase(getYukbulMessagesMobile.rejected, (state, action)=> {
            state.isLoadingGetYukbulMessages = false
        })
        //! getLookingLoadAdmin
        .addCase(getLookingLoadAdmin.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getLookingLoadAdmin.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.lookingLoadList = action.payload.items.$values
            state.lookingLoadListCount = action.payload.count
        })
        .addCase(getLookingLoadAdmin.rejected, (state, action)=> {
            state.isLoadingGet = false
        })
        //! getLookingLoadInfoAdmin
        
        .addCase(getLookingLoadInfoAdmin.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getLookingLoadInfoAdmin.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.lookinLoadInfo = action.payload.$values
        })
        .addCase(getLookingLoadInfoAdmin.rejected, (state, action)=> {
            state.isLoadingGet = false
        })

        //! deleteYukBulItems
        .addCase(deleteYukBulItems.pending, (state)=> {
          state.isLoadingDeleteYukBulItems = true
        })
        .addCase(deleteYukBulItems.fulfilled, (state, action)=> {
            state.isLoadingDeleteYukBulItems = false
            state.yukBulSelectedMessages = []
        })
        .addCase(deleteYukBulItems.rejected, (state, action)=> {
            state.isLoadingDeleteYukBulItems = false
        })


        //! shareYukBulItems
        .addCase(shareYukBulItems.pending, (state)=> {
          state.isLoadingShareYukBulItems = true
        })
        .addCase(shareYukBulItems.fulfilled, (state, action)=> {
            state.isLoadingShareYukBulItems = false
            state.yukBulSelectedMessages = []
        })
        .addCase(shareYukBulItems.rejected, (state, action)=> {
            state.isLoadingShareYukBulItems = false
        })

        //! smsReportList
        .addCase(getFailedNetgsmSmsReport.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getFailedNetgsmSmsReport.fulfilled, (state, action)=> {
            state.isLoadingGet = false
            state.smsReportList = action.payload
        })
        .addCase(getFailedNetgsmSmsReport.rejected, (state, action)=> {
            state.isLoadingGet = false
        })

        //! sayfa veya menü oluşturma
        .addCase(addNewPageOrMenu.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(addNewPageOrMenu.fulfilled, (state, action)=> {
            state.isLoadingAdd = false
        })
        .addCase(addNewPageOrMenu.rejected, (state, action)=> {
            state.isLoadingAdd = false
        })

        //! sayfa veya menü güncelleme
        
        .addCase(updatePageOrMenu.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(updatePageOrMenu.fulfilled, (state, action)=> {
            state.isLoadingAdd = false
        })
        .addCase(updatePageOrMenu.rejected, (state, action)=> {
            state.isLoadingAdd = false
        })

        //! sayfa veya menü silme
        
        .addCase(deletePageOrMenu.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(deletePageOrMenu.fulfilled, (state, action)=> {
            state.isLoadingAdd = false
        })
        .addCase(deletePageOrMenu.rejected, (state, action)=> {
            state.isLoadingAdd = false
        })
        
         //! mobil feedback
        .addCase(getCallFeedback.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getCallFeedback.fulfilled, (state, action)=> {
          state.isLoadingGet = false
          state.feedBackList = action.payload.items.$values
          state.feedBackListCount = action.payload.count
        })
        .addCase(getCallFeedback.rejected, (state)=> {
          state.isLoadingGet = false
        })  

        //! portal tüm roller
        
        .addCase(getAllAppRole.pending, (state)=> {
          state.isLoadingGet = true
        })
        .addCase(getAllAppRole.fulfilled, (state, action)=> {
          state.isLoadingGet = false
          state.appRoleList = action.payload.$values
        })
        .addCase(getAllAppRole.rejected, (state)=> {
          state.isLoadingGet = false
        }) 

        //! portal rol ismi güncelle
        .addCase(updateAppRole.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(updateAppRole.fulfilled, (state, action)=> {
          state.isLoadingAdd = false
        })
        .addCase(updateAppRole.rejected, (state)=> {
          state.isLoadingAdd = false
        }) 
        //! adminin rolleri
        .addCase(getRoleClaim.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(getRoleClaim.fulfilled, (state, action)=> {
          state.isLoadingAdd = false
          state.adminRoleList = action.payload.$values
        })
        .addCase(getRoleClaim.rejected, (state)=> {
          state.isLoadingAdd = false
        }) 
        //! adminlerin alabileceği rollerin listesi
        .addCase(getAllClaimsByRole.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(getAllClaimsByRole.fulfilled, (state, action)=> {
          state.isLoadingAdd = false
          state.allClaimsByRole = action.payload.$values
        })
        .addCase(getAllClaimsByRole.rejected, (state)=> {
          state.isLoadingAdd = false
        })

        //! rol tanımlama
        .addCase(addRoleClaim.pending, (state)=> {
          state.isLoadingAdd = true
        })
        .addCase(addRoleClaim.fulfilled, (state, action)=> {
          state.isLoadingAdd = false
        })
        .addCase(addRoleClaim.rejected, (state)=> {
          state.isLoadingAdd = false
        })

        //! getDeleteUserRequestsForPortal
        .addCase(getDeleteUserRequestsForPortal.pending, (state)=> {
          state.isLoadingGetDeleteUserRequestsForPortal = true
        })
        .addCase(getDeleteUserRequestsForPortal.fulfilled, (state, action)=> {
          state.isLoadingGetDeleteUserRequestsForPortal = false
          state.deleteUserRequestsForPortalList = action.payload.data.items.$values
          state.deleteUserRequestsForPortalCount = action.payload.data.count
          state.deleteUserRequestsForPortalSize = action.payload.data.size
        })
        .addCase(getDeleteUserRequestsForPortal.rejected, (state)=> {
          state.isLoadingGetDeleteUserRequestsForPortal = false
        })


        
  },
});


export const {  
  setBlockingMessageFilterItem,
  setYukbulMessages,
  setYukBulSelectedMessages,
  setSelectedMenu,
  setSelectedPage,
  setSelectedRole
} = admin5Slice.actions;
export default admin5Slice.reducer;
